import { style } from "@vanilla-extract/css";

export const container = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  minHeight: "100vh",
  padding: "var(--cp-spacing-large)",
  // Offset for the fixed 57px auth header (see auth/layout.css.ts).
  paddingBlockStart: "calc(57px + var(--cp-spacing-3xlarge))",
  backgroundColor: "var(--cp-color-white)",

  "@media": {
    "(max-width: 767px)": {
      minHeight: "unset",
      height: "100dvh",
      overflow: "hidden",
      overscrollBehavior: "none",
      paddingInline: "var(--cp-base-spacing-3xlarge)",
      paddingBlockStart: "57px",
      justifyContent: "center",
    },
  },
});

export const card = style({
  width: "100%",
  maxWidth: "440px",

  "@media": {
    "(max-width: 767px)": {
      maxWidth: "100%",
    },
    "(min-width: 768px) and (max-width: 1023px)": {
      maxWidth: "480px",
    },
    "(min-width: 1024px)": {
      maxWidth: "440px",
    },
  },
});

export const header = style({
  textAlign: "center",
  marginBlockEnd: "var(--cp-spacing-3xlarge)",
});

// Two-layer illustration for forgot-password — matches the prototype at
// apps/web/src/app/(prototype)/(unauth)/forgot-password/styles.module.css.
export const fpIllustration = style({
  position: "relative",
  width: "120px",
  height: "120px",
  overflow: "hidden",
  flexShrink: 0,
  marginInline: "auto",
  marginBlockEnd: "var(--cp-spacing-small)",
});

export const fpIllustrationLayerNeutral = style({
  position: "absolute",
  inset: "10.39% 2.51% 17.28% 3.8%",
});

export const fpIllustrationLayerBranded = style({
  position: "absolute",
  inset: "33.05% 14.98% 10.41% 2.5%",
  vars: {
    "--fill-0": "var(--cp-action-color-branded-primary-enabled)",
  },
});

export const illustrationImg = style({
  position: "absolute",
  display: "block",
  width: "100%",
  height: "100%",
  maxWidth: "none",
});

export const title = style({
  font: "var(--cp-text-display2xlarge)",
  color: "var(--cp-color-text-primary)",
  marginBlockEnd: "var(--cp-spacing-small)",
  marginBlockStart: "0",

  "@media": {
    "(max-width: 767px)": {
      font: "var(--cp-text-display-xlarge)",
    },
  },
});

export const subtitle = style({
  font: "var(--cp-text-subtitle-large)",
  color: "var(--cp-color-text-primary)",
  marginBlockStart: "0",
  marginBlockEnd: "0",
});

export const fullWidth = style({
  width: "100%",
});

export const link = style({
  textDecoration: "none",
});

export const backToLoginLink = style({
  display: "block",
  width: "100%",
  textDecoration: "none",
  "@media": {
    "(max-width: 767px)": { display: "none" },
  },
});

export const backLink = style({
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--cp-spacing-xsmall)",
  color: "var(--cp-action-color-branded-primary-enabled)",
  textDecoration: "none",
  font: "var(--cp-text-body-medium)",
  marginBlockEnd: "var(--cp-spacing-2xlarge)",
  selectors: {
    "&:hover": {
      color: "var(--cp-action-color-branded-primary-hover)",
    },
  },
  "@media": {
    "(max-width: 767px)": { display: "none" },
  },
});

export const rulesList = style({
  listStyle: "none",
  padding: "0",
  margin: "0",
  display: "flex",
  flexDirection: "column",
  gap: "var(--cp-spacing-xsmall)",
});

export const ruleItem = style({
  display: "flex",
  alignItems: "center",
  gap: "var(--cp-spacing-xsmall)",
  font: "var(--cp-text-body-small)",
  color: "var(--cp-color-text-secondary)",
});

export const ruleItemMet = style({
  color: "var(--cp-color-signal-success-enabled)",
});

export const ruleIcon = style({
  flexShrink: 0,
  width: "16px",
  height: "16px",
});

export const cooldownText = style({
  font: "var(--cp-text-body-small)",
  color: "var(--cp-color-text-secondary)",
  textAlign: "center",
});
